import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { data } from 'services';
import { required as requiredValidation } from '../validation';
import { Multiselect } from './fields';
import { MultiInput } from './multi-input';
import { StyledSelect } from './dict-filter.styled';

export const DictFilter = (props) => {
  const { t } = useTranslation();
  const { w = 110, exclude = [], theme = '', multiple = false, withEmpty = true, emptyName = t('filter.Все'), required = false, name, dict, force_name, ...rest } = props;
  const wOk = w + 'px';
  const requiredT = useCallback(requiredValidation(t), [t]);
  if (required) {
    rest.validate = requiredT;
  }

  const dictionary = data.getDict(dict);
  if (!dictionary) {
    return null;
  }

  // items
  const items = dictionary.items.filter((el) => !exclude.includes(el.value));

  // get items el
  const getItemsEl = () => {
    return items.map((el, idx) => {
      let val = el.value;
      return (
        <option key={idx} value={val}>
          {el.name}
        </option>
      );
    });
  };

  const title = t(`dict_filter.${dictionary.title}`);

  const nameOk = force_name ?? (dictionary.param ? dictionary.param : name);
  const optionsEl = getItemsEl();

  // multiple
  if (multiple) {
    const itemsOk = items.map((el) => {
      return { id: el.value, name: el.name };
    });
    return (
      <Multiselect type="multiselect" label={title} additionalComponent={MultiInput} data={itemsOk} countDisplayedIcons={3} width={wOk} name={nameOk} theme={theme} {...rest} />
    );
  }

  return (
    <StyledSelect type="select" width={wOk} name={nameOk} label={title} theme={theme} {...rest}>
      {withEmpty && <option value="">{emptyName}</option>}
      {optionsEl}
    </StyledSelect>
  );
};

DictFilter.propTypes = {
  dict: PropTypes.string.isRequired,
  name: PropTypes.string,
  w: PropTypes.number,
  multiple: PropTypes.bool,
  type: PropTypes.string,
  theme: PropTypes.string,
  exclude: PropTypes.array,
};
